'use strict';

var scrollAnimate = require('./scrollAnimate');

module.exports = function () {
    $('.back-to-top').click(function () {
        scrollAnimate(0);
    });

    $(document).on('click', '.js-open-size-chart-footer', function (e) {
        // analytics
        dataLayer.push({
            event: 'sizeChart',
            eventCategory: 'Size Chart Footer',
            eventAction: 'open'
        });
        // END
    });

    if ($('.js-copyright-year').length) {
        var d = new Date();
        var year = d.getFullYear();
        var value = parseInt($('.js-copyright-year').html());
        if (value !== year) {
            $('.js-copyright-year').html(year);
        }
    }

    $(document).on('click', '.js-footer-newsletter-button', function(){
        var target = $(this).attr('data-target');
        var email = $(this).closest('.cc-footer-newsletter').find('.js-email-footer:visible').val();
        if (target) {
            $(document).trigger('overlaynewsletter:showmodal', {
                target: target,
                source: 'footer',
                email: email,
            });
        }
    });
};
